import { useState, FocusEventHandler } from 'react'
import Select from 'react-select'
import { Box } from 'theme-ui'
import theme from 'theme'
import { ChevronDownIcon } from 'components/Icon'
import { customSelectStyles } from './styles'
import { noop } from 'utils'

export type LocaleOption = {
  value: string
  label: string
}

export const localeOptions: LocaleOption[] = [
  { value: 'en-US', label: 'English' },
  { value: 'es-ES', label: 'Spanish' },
  // { value: 'pt-PT', label: 'Portuguese' },
  // { value: 'fr-FR', label: 'French' },
]

export type LocaleSelectProps = {
  name: string
  value?: string
  disabled?: boolean
  tabIndex?: string | null | undefined | number
  hasErrors?: boolean
  onChange?: (locale: LocaleOption) => void
  onBlur?: FocusEventHandler
  'data-cy'?: string
}

const DropdownIndicator = () => (
  <Box sx={{ width: 20, height: 20 }}>
    <ChevronDownIcon />
  </Box>
)

export const LocaleSelect = ({
  name,
  value,
  tabIndex,
  disabled = false,
  hasErrors = false,
  onChange = noop,
  onBlur = noop,
  ...props
}: LocaleSelectProps) => {
  const [focused, setFocused] = useState(false)

  return (
    <Box
      data-cy={props['data-cy']}
      sx={{
        p: '10px',
        boxSizing: 'border-box',
        width: '100%',
        bg: 'oldlace',
        borderRadius: 8,
        boxShadow: hasErrors
          ? '0 0 0 2px #f87e0e'
          : focused
          ? '0 0 0 2px #ffc436'
          : 'none',
        opacity: disabled ? 0.6 : 1,
      }}
    >
      <Select
        aria-label={`select-${name}`}
        placeholder="Select a language"
        name={name}
        options={localeOptions}
        getOptionLabel={(option) => option.label}
        getOptionValue={(option) => option.value}
        value={localeOptions.find((o) => o.value === value) || ''}
        components={{ DropdownIndicator }}
        styles={customSelectStyles}
        theme={(t) => ({
          ...t,
          colors: {
            ...t.colors,
            primary: theme.colors.primary,
            primary50: theme.colors.darkyellow,
            primary25: theme.colors.oldlace,
          },
        })}
        tabIndex={`${tabIndex}`}
        isDisabled={disabled}
        onChange={onChange}
        onFocus={() => setFocused(true)}
        onBlur={(evt) => {
          onBlur(evt)
          setFocused(false)
        }}
        isSearchable
      />
    </Box>
  )
}
